import { render, staticRenderFns } from "./AdminEditGV20.vue?vue&type=template&id=305cf997&scoped=true&"
import script from "./AdminEditGV20.vue?vue&type=script&lang=js&"
export * from "./AdminEditGV20.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditGV20.vue?vue&type=style&index=0&id=305cf997&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305cf997",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('305cf997')) {
      api.createRecord('305cf997', component.options)
    } else {
      api.reload('305cf997', component.options)
    }
    module.hot.accept("./AdminEditGV20.vue?vue&type=template&id=305cf997&scoped=true&", function () {
      api.rerender('305cf997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/device_types/AdminEditGV20.vue"
export default component.exports